export default __webpack_public_path__ + "static/media/40211.9574280a.jpg";